import Vue from 'vue';
import { isPrimitive } from 'vue-class-component/lib/util';
import { createVueDataProxy } from '@tencent/ui-core/lib/utils/vue';
import { getStateMeta } from "../../state/utils/StateMeta";
import { cloneDeep, get, has, isObjectLike } from "lodash-es";
import { getIsEditorMode } from "../../../tools/designer/getIsEditorMode";
import { createReadOnlyProxy } from "../../../tools/lang";
import { hideProp } from "../../../tools/hideProp";
export function StateProxy(target, prop) {
  Object.defineProperty(target, prop, {
    // set定义在原型上，只会在构造器中执行一次，后面的set会走到实例(this)上的set
    set(val) {
      var _this$options$sourceC2;
      if (getIsEditorMode()) {
        var _this$options$sourceC;
        const field = (_this$options$sourceC = this.options.sourceConfig) === null || _this$options$sourceC === void 0 || (_this$options$sourceC = _this$options$sourceC.fields) === null || _this$options$sourceC === void 0 ? void 0 : _this$options$sourceC.find(item => item.id === prop);
        if (field !== null && field !== void 0 && field['ds:useExample']) {
          defineExampleProperty(this, prop);
          return;
        }
      }
      if ((_this$options$sourceC2 = this.options.sourceConfig) !== null && _this$options$sourceC2 !== void 0 && _this$options$sourceC2.useProxy) {
        defineProxyProperty(this, prop, val);
        return;
      }
      Vue.util.defineReactive(this, prop, val);
    },
    get() {
      if (process.env.NODE_ENV !== 'production') {
        throw new Error(`This property [${String(prop)}] must be initialized`);
      }
    }
  });
  const meta = getStateMeta(target.constructor);
  meta.proxyProperties.push(prop);
}
const prefix = '__@@proxy_state_';
export function defineProxyProperty(state, prop, value) {
  const privateKey = Symbol(`${prefix}${prop}`);
  // 定义隐藏的代理属性 for: state.formData = newValue
  Vue.util.defineReactive(state, privateKey, value);
  Object.defineProperty(state, privateKey, {
    enumerable: false
  });
  // 拦截判断赋值类型，创建代理  for: state.formData.xxx = newValue
  Object.defineProperty(state, prop, {
    set(val) {
      const value = isPrimitive(val) ? val : createVueDataProxy(val);
      this[privateKey] = value;
    },
    get() {
      return state[privateKey];
    },
    enumerable: true,
    configurable: true
  });
}
const exampleProxyKey = '__@@exampleProxyKey';
export function defineExampleProperty(state, prop) {
  if (!has(state, exampleProxyKey)) {
    hideProp(state, exampleProxyKey, {
      value: Vue.observable({})
    });
  }
  Object.defineProperty(state, prop, {
    get() {
      var _state$options$source;
      const field = (_state$options$source = state.options.sourceConfig) === null || _state$options$source === void 0 || (_state$options$source = _state$options$source.fields) === null || _state$options$source === void 0 ? void 0 : _state$options$source.find(item => item.id === prop);
      if (!field) {
        console.warn(`找不到[${prop}]对应的字段配置`);
      }
      const example = field === null || field === void 0 ? void 0 : field.example;
      const exampleProxy = get(this, exampleProxyKey);
      if (!has(exampleProxy, prop)) {
        const cloneValue = cloneDeep(example);
        const value = isObjectLike(example) ? createReadOnlyProxy(cloneValue) : cloneValue;
        Vue.set(exampleProxy, prop, value);
      }
      return exampleProxy[prop];
    },
    set(_value) {
      // empty 示例值不允许写
    },
    enumerable: true,
    configurable: true
  });
}
//# sourceMappingURL=defineProxyState.js.map
